import axios from "axios";
import apiConfig from "../pages/credentials/apiConfig";

export const USER_INFO = "USER_INFO";

export const getUserInfo = (user) => {
    return {
        type: USER_INFO,
        payload: user,
    };
};

export const fetchUserData = undefined;